import _ from 'lodash'
import fileInfo from 'scoreboard/components/files/file-info'

function filenameIsSpreadsheet(filename) {
	return _.includes(fileInfo.extensions.spreadsheet, fileInfo.extension(filename))
}

function filenameIsExcelFile(filename) {
	return _.includes(fileInfo.extensions.excel, fileInfo.extension(filename))
}

module.exports = {
	filenameIsSpreadsheet,
	filenameIsExcelFile
}